import useFrameworkTranslation from 'framework/language/useFrameworkTranslation';
import React, { useState } from 'react';
import aryApiTypes from '../constants/aryApiTypes';
import AryCurrencyAutoComplete from './AryCurrencyAutoComplete';
import AryLockableTextField from './AryLockableTextField';

const AryCurrencyTextField = (props) => {
  const {
    currencyLabel,
    currencyValue,
    onCurrencyChange,
    excludedCurrencyCodes,
    onlyCurrencyCodes,
    fixedCurrencyCode,
    disabled,
    currencyDisabled,
    currencyMaxHeight,
    getMirrorCurrencies,
    branchId,
    handleChangeCurrencyCounts,
    apiType = aryApiTypes.graphql,
    error,
    required,
    customAdornment,
    value,
    onMenuOpen,
    ...others
  } = props;

  const { t } = useFrameworkTranslation();
  const [decimalPlaces, setDecimalPlaces] = useState(2);
  const handleChangeDecimalPlaces = (places) => {
    setDecimalPlaces(places);
  };
  const [menuIsOpen, setMenuIsOpen] = useState(false);

  return (
    <div style={{ marginBottom: others.openedMenuMarginBottom ? menuIsOpen ? others.openedMenuMarginBottom : 0 : 'unset' }}>
      <AryLockableTextField
        removeAdditionalPadding
        decimalPlaces={decimalPlaces}
        customAdornment={customAdornment}
        disabled={!(currencyValue || fixedCurrencyCode) || disabled}
        error={error}
        value={value}
        currencyCode={fixedCurrencyCode || currencyValue}
        {...others}
      >
        <div style={{ width: '120px' }}>
          <AryCurrencyAutoComplete
            value={fixedCurrencyCode || currencyValue}
            onChange={onCurrencyChange}
            label={`${currencyLabel || t('currency')}${required ? ' *' : ''}`}
            disabled={currencyDisabled || fixedCurrencyCode}
            handleChangeDecimalPlaces={handleChangeDecimalPlaces}
            excludedCurrencyCodes={excludedCurrencyCodes}
            onlyCurrencyCodes={onlyCurrencyCodes}
            getMirrorCurrencies={getMirrorCurrencies}
            branchId={branchId}
            maxheight={currencyMaxHeight}
            apiType={apiType}
            handleChangeCurrencyCounts={handleChangeCurrencyCounts}
            error={error}
            style={{
              control: {
                borderRadius: '4px 0 0 4px',
                borderRight: 0
              },
              dropdownIndicator: {
                ...others.dropdownIndicatorSx
              },
              ...others.style
            }}
            menuIsOpen={menuIsOpen}
            onMenuOpen={() => {
              if (onMenuOpen) {
                onMenuOpen(true);
              }
              setMenuIsOpen(true);
            }}
            onMenuClose={() => {
              if (onMenuOpen) {
                onMenuOpen(false);
              }
              setMenuIsOpen(false);
            }}
          />
        </div>
      </AryLockableTextField>
    </div>
  );
};

export default AryCurrencyTextField;
